/* eslint-disable @typescript-eslint/no-explicit-any */
import { documentToHtmlString, Options } from '@contentful/rich-text-html-renderer';
import { IBenefitsItem, IBenefitsItemResponse, IBenefitsItems, IBenefitsResponse } from '../../interfaces/benefits';
import { HttpErrorResponse } from '@angular/common/http';
import { LegalEntityCountry } from '../../interfaces/legal-entity';

export class BenefitsHelper {
  static benefitAssets = new Map();

  /**
   * Save benefit assets.
   *
   * Background:
   * In description field we let user to embed assets in the content.
   * To render them properly in sectionRenderer we must save them in the map
   * and then access the data from renderer's code.
   * @param links
   */
  static saveBenefitAssets(links: any) {
    links.assets.block.forEach((asset) => {
      BenefitsHelper.benefitAssets.set(asset.sys.id, asset);
    });
  }

  static getBenefitHandler(
    benefitItem: IBenefitsItemResponse,
    sectionRendererOptions: Partial<Options>
  ): IBenefitsItem {
    if (!benefitItem) {
      throw new HttpErrorResponse({ status: 404, statusText: 'Not found' });
    }

    if (benefitItem.description?.links) {
      BenefitsHelper.saveBenefitAssets(benefitItem.description.links);
    }

    return {
      id: benefitItem.sys.id,
      name: benefitItem.name,
      subtitle: benefitItem.subtitle,
      countries: benefitItem.countries as Array<LegalEntityCountry>,
      mainImage: benefitItem.mainImage.url,
      description: documentToHtmlString(
        benefitItem.description?.json as any,
        sectionRendererOptions
      ),
      descriptionImages: benefitItem.descriptionImagesCollection.items.map(
        (item) => item.url
      ),
      attachment: {
        url: benefitItem.attachment?.url,
        fileName: benefitItem.attachment?.fileName
      },
      attachmentDescription: documentToHtmlString(
        benefitItem.attachmentDescription?.json as any,
        sectionRendererOptions
      ),
      dateCreated: benefitItem.dateCreated,
      categories: benefitItem.categories,
      isFeatured: benefitItem.isFeatured,
      accessButtonLabel: benefitItem.accessButtonLabel,
      accessInfo: documentToHtmlString(
        benefitItem.accessInfo?.json as any,
        sectionRendererOptions
      ),
      accessCode: benefitItem.accessCode,
      consultantAccess: benefitItem.consultantAccess,
      isMedicoverPlatform: benefitItem.isMedicoverPlatform
    };
  }


  static getBenefitsHandler(
    benefitsResponse: IBenefitsResponse,
    sectionRendererOptions: Partial<Options>
  ): IBenefitsItems {
    const results: Array<IBenefitsItem> = benefitsResponse.items.map((entry) => {
      return {
        id: entry.sys.id,
        name: entry.name,
        subtitle: entry.subtitle,
        countries: entry.countries as Array<LegalEntityCountry>,
        mainImage: entry.mainImage.url,
        description: documentToHtmlString(
          entry.description?.json as any,
          sectionRendererOptions
        ),
        descriptionImages: entry.descriptionImagesCollection.items.map(
          (item) => item.url
        ),
        attachment: {
          url: entry.attachment?.url,
          fileName: entry.attachment?.fileName
        },
        attachmentDescription: documentToHtmlString(
          entry.attachmentDescription?.json as any,
          sectionRendererOptions
        ),
        dateCreated: entry.dateCreated,
        categories: entry.categories,
        isFeatured: entry.isFeatured,
        accessButtonLabel: entry.accessButtonLabel,
        accessInfo: documentToHtmlString(
          entry.accessInfo.json as any,
          sectionRendererOptions
        ),
        accessCode: entry.accessCode,
        consultantAccess: entry.consultantAccess,
        isMedicoverPlatform: entry.isMedicoverPlatform
      }
    });

    return {
      ...benefitsResponse,
      items: results
    };
  }
}
